<app-loading *ngIf="viewModel.isLoading$ | async" [options]="viewModel?.loadingOpts$ | async"> </app-loading>

<lib-sticky-modal>
  <lib-sticky-header [stickyCollectionKey]="stickyCollectionKey" [stickyOrder]="0">
    <div class="modal-header">
      <div class="modal-title">Add New Display</div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body [placeInSameZPlaneAsHeaderAndFooter]="true">
    <h5 class="mt-40px mb-4"><b>Display Info</b></h5>
    <lib-reactive-form-group
      #newDisplayInput
      class="mb-4"
      [bindTo]="newDisplay"
      (canSubmit$)="canSubmitForm$.next($event)"
      (formSubmitted$)="viewModel.createNewDisplay($event)">
      <lib-reactive-form-column-layout [nColumns]="2">
        <lib-reactive-form-text
          data-testid="new-display-modal-name-input"
          [inputName]="'name'"
          [label]="'Display Name'"
          [placeholder]="'Enter the display name'"
          [bindingProperty]="'name'"
          [required]="true"
          [minLength]="1"
          [maxLength]="128">
        </lib-reactive-form-text>

        <lib-reactive-form-searchable-drop-down
          data-testid="new-display-modal-size-dropdown"
          [inputName]="'displaySize'"
          [label]="'Display Size'"
          [placeholder]="'Select the size of this display'"
          [bindingProperty]="'displaySize.name'"
          [required]="true"
          [sortDropdownListBy]="null"
          [dropdowns]="defaultSizes$ | async"></lib-reactive-form-searchable-drop-down>

        <lib-reactive-form-searchable-drop-down
          data-testid="new-display-modal-orientation-dropdown"
          [inputName]="'orientation'"
          [label]="'Orientation'"
          [placeholder]="'Orientation'"
          [bindingProperty]="'displaySize.orientation'"
          [required]="true"
          [tooltip]="'Portrait is a 90º clockwise rotation. Reverse portrait is a 90º counterclockwise rotation.'"
          [dropdowns]="orientations$ | async"></lib-reactive-form-searchable-drop-down>

        <lib-reactive-form-searchable-drop-down
          data-testid="new-display-modal-default-menu-dropdown"
          [inputName]="'defaultMenu'"
          [label]="'Default Menu'"
          [placeholder]="'Select an active menu for this display'"
          [bindingProperty]="'defaultMenu'"
          [required]="true"
          [dropdownGroupings]="viewModel.menuOptionGroupings$ | async"
          [dropdowns]="viewModel.menuOptions$ | async"></lib-reactive-form-searchable-drop-down>
      </lib-reactive-form-column-layout>
    </lib-reactive-form-group>
  </lib-sticky-body>
  <lib-sticky-footer>
    <lib-button-layout>
      <lib-button-neutral data-testid="new-display-modal-cancel-button" (buttonClicked)="cancel()"
        >Cancel</lib-button-neutral
      >
      <lib-button-primary
        data-testid="new-display-modal-save-button"
        (buttonClicked)="newDisplayInput.submitForm()"
        [disabled]="!(canSubmitForm$ | async)">
        Save Display
      </lib-button-primary>
    </lib-button-layout>
  </lib-sticky-footer>
</lib-sticky-modal>
